import * as React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_QUERY } from 'const/queries';
import { WEBHOOK_DELETE, WEBHOOK_UPDATE } from 'const/mutations';
import { WebhookFormView } from './view';
import { cleanPayload } from 'utils/formutils';

export function WebhookEditForm() {
    const navigate = useNavigate();
    const { id: appId, wid: webhookId } = useParams<{ id: string; wid: string }>();
    const DASHBOARD_LINK = '/extranet/apps/' + appId + '/dashboard';

    const { data } = useQuery(APP_QUERY, {
        variables: { id: appId },
    });
    const app = data && data.app;
    // eslint-disable-next-line eqeqeq
    const webhook = data?.app.webhookSubscriptions.find(p => p.id == webhookId);

    const [webhookUpdate, { loading: saving }] = useMutation(WEBHOOK_UPDATE, {
        onCompleted() {
            navigate(DASHBOARD_LINK);
        },
    });

    const [webhookDelete, { loading: deleting }] = useMutation(WEBHOOK_DELETE, {
        onCompleted() {
            navigate(DASHBOARD_LINK);
        },
    });

    const onSubmit = (values, form, callback) => {
        values.id = webhookId;
        webhookUpdate({ variables: cleanPayload(values) })
            .then(() => {
                callback();
            })
            .catch(err => callback(err));
    };

    const onDelete = () => {
        webhookDelete({ variables: { id: webhookId } });
    };

    const onCancel = () => {
        navigate(DASHBOARD_LINK);
    };

    return (
        <WebhookFormView
            app={app}
            webhook={webhook}
            loading={saving}
            deleting={deleting}
            onCancel={onCancel}
            onSubmit={onSubmit}
            onDelete={onDelete}
        />
    );
}
